module.exports = __webpack_public_path__ + "img/two-yellow-fire.f35733fa.svg";